export default {
  passwordReset: {
    heading: 'Passwort vergessen?',
    submitButton: 'Passwort zurücksetzen',
    form: {
      password: 'Passwort',
      passwordConfirmation: 'Passwort bestätigen',
    },
    formSuccessMessage: 'Passwort wurde erfolgreich geändert!',
    formErrorMessage: 'Es gab einen Fehler. Bitte überprüfe Deine Eingabe.',
    invalidLink:
      'Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen. Bitte fordere einen neuen Link an.',
    userNotFound:
      'Kein Konto mit dieser E-Mail-Adresse gefunden. Bitte überprüfe Deine E-Mail-Adresse und versuche es erneut.',
  },
}
